import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { LEGENDTEAM_URL, LOGO_URL } from "@/lib/constants";

const MCG = { logo: "/sponsors/mcg.png", url: "https://mulinaricostruzioni.it", name: "MCG — Mulinari Costruzioni" };
const LEGEND = { logo: LOGO_URL, url: LEGENDTEAM_URL, name: "Legend Team" };

export default function Ticker({ items = [] }) {
  // Normalize to objects {title, slug}
  const norm = (items.length ? items : [{ title: "Benvenuti su Legend Magazine", slug: null }]).map(
    (it) => (typeof it === "string" ? { title: it, slug: null } : it)
  );

  // Build the running sequence with brand logos interleaved every few articles
  const nodes = [];
  norm.forEach((it, idx) => {
    nodes.push({ kind: "art", ...it });
    if ((idx + 1) % 4 === 0) nodes.push({ kind: "brand", ...MCG });
    if ((idx + 1) % 7 === 0) nodes.push({ kind: "brand", ...LEGEND });
  });
  const doubled = [...nodes, ...nodes];

  const Brand = ({ n }) => (
    <a href={n.url} target="_blank" rel="noreferrer" title={n.name} data-testid={`ticker-brand-${n.name.split(" ")[0].toLowerCase()}`} className="mx-6 inline-flex items-center align-middle">
      <span className="bg-white rounded-sm px-2 h-6 inline-flex items-center hover:ring-2 hover:ring-legend-yellow transition">
        <img src={n.logo} alt={n.name} className="h-4 max-w-[80px] object-contain" />
      </span>
    </a>
  );

  return (
    <div data-testid="scrolling-ticker" className="bg-legend-red text-white border-y border-legend-dark overflow-hidden">
      <div className="flex items-stretch">
        <div className="flex items-center gap-2 bg-legend-ink px-4 py-2 font-display font-bold uppercase text-sm tracking-wider shrink-0 z-10">
          <Zap size={16} className="text-legend-yellow" /> Ultim'ora
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex items-center whitespace-nowrap animate-marquee py-2 hover:[animation-play-state:paused]">
            {doubled.map((n, i) =>
              n.kind === "brand" ? (
                <Brand key={i} n={n} />
              ) : n.slug ? (
                <Link
                  key={i}
                  to={`/articolo/${n.slug}`}
                  data-testid="ticker-article-link"
                  className="mx-6 text-sm font-mono tracking-wide inline-flex items-center gap-6 hover:text-legend-yellow underline-offset-4 hover:underline transition-colors"
                >
                  {n.title}<span className="text-legend-yellow">◆</span>
                </Link>
              ) : (
                <span key={i} className="mx-6 text-sm font-mono tracking-wide inline-flex items-center gap-6">
                  {n.title}<span className="text-legend-yellow">◆</span>
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
